const salesSalaryInfo = [{
  desc: '获取业务员薪资',
  options: {
    url: '/salesSalaryInfo/queryPage',
    method: 'post'
  }
}, {
  desc: '编辑业务员薪资',
  options: {
    url: '/salesSalaryInfo/updateSalesSalaryInfo',
    method: 'post'
  }
}, {
  desc: '批量删除业务员薪资',
  options: {
    url: '/salesSalaryInfo/batchDeleteSalesSalaryInfo',
    method: 'post'
  }
}, {
  desc: '加扣款导出',
  options: {
    url: '/salesDeduction/export',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '加扣款导入',
  options: {
    url: '/salesDeduction/import',
    method: 'post'
  }
}, {
  desc: '加扣款列表',
  options: {
    url: '/salesDeduction/queryList',
    method: 'post'
  }
}, {
  desc: '删除加扣款',
  options: {
    url: '/salesDeduction/remove',
    method: 'delete',
    argsParams: true
  }
}, {
  desc: '批量删除业务员薪资',
  options: {
    url: '/salesDeduction/save',
    method: 'post'
  }
}]
export default salesSalaryInfo



// WEBPACK FOOTER //
// ./src/api/salesSalaryInfo.js